<template>
  <div>
    <details-component
      :gallery="gallery"
      :name="place.name"
      :address="place.address"
      :description="place.description"
      :tags="place.tags"
      :visible="visible"
      @close="handleClose"
      @transitionEnd="setPlace"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DetailsComponent from '@/containers/Details/Details'

export default {
  components: {
    DetailsComponent
  },
  data () {
    return {
      place: {
        photos: [],
        youtubeId: '',
        name: '',
        address: '',
        description: '',
        tags: []
      },
      visible: false
    }
  },
  computed: {
    ...mapGetters(['activePlace']),
    galleryPhotos () {
      const { photos = [] } = this.place
      return photos.map(photo => ({ src: photo, type: 'photo' }))
    },
    gallery () {
      const { youtubeId } = this.place
      return youtubeId
        ? [{ src: youtubeId, type: 'video' }, ...this.galleryPhotos]
        : this.galleryPhotos
    }
  },
  watch: {
    activePlace () {
      if (this.place.name && this.activePlace.name !== this.place.name) {
        this.visible = false
      } else {
        this.setPlace()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setPlace()
    })
  },
  methods: {
    handleClose () {
      this.$router.push({ name: 'map' })
    },
    setPlace () {
      this.place = this.activePlace
      this.visible = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Details/DetailsContainer.vue